export default __webpack_public_path__ + "static/Basement-Cleanout-4d004b72e574891e8ba11c759ad9e860.jpg";